import { Component, inject } from "@angular/core";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { environment } from "../../../../../environments/env";
import { CookieConsentService } from "../../../../shared/services/cookie-consent.service";

@Component({
  selector: "app-footer",
  imports: [RouterLink, RouterLinkActive],
  templateUrl: "./footer.component.html",
  styleUrl: "./footer.component.css",
})
export class FooterComponent {
  ENV = environment;
  private _consent = inject(CookieConsentService);

  // Get current year in format YYYY
  get Year() {
    return new Date().getFullYear();
  }

  openCookiePrefs(): void {
    this._consent.reopen();
  }
}
